import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LoadViewNoLocations() {
  const { t } = useTranslation(["fit"]);

  return (
    <div className="flex h-full items-center justify-center">
      <div className="p-6 text-center">
        <MapPin className="text-muted-foreground mx-auto mb-4 h-12 w-12" />
        <h3 className="text-foreground mb-2 text-lg font-medium">{t("fit:NoVehiclesToLoad")}</h3>
        <p className="text-muted-foreground text-sm">{t("fit:NoVehiclesToLoadDescription")}</p>
      </div>
    </div>
  );
}
